import './Title.css';
import React from 'react';
import PropTypes from 'prop-types'

const Title = ({text}) => {
    return (
        <div className="title-container" aria-labelledby="title-text">
            <h2 className="title-text" id="title-text">{text}</h2>
            <div className="title-line" aria-hidden="true"></div>
        </div>
    );
}

Title.propTypes = {
    text: PropTypes.string.isRequired,
};

export default Title;
